import { NotificationType } from 'models'

export enum EntityType {
  PROJECT = 'Project'
}

export enum UserNotificationStatus {
  NEW = 'NEW',
  ACKNOWLEDGED = 'ACKNOWLEDGED'
}

export interface UserNotificationDTO {
  id: number
  userId: number
  entityId: number
  entityTitle: string
  entityType: EntityType
  notificationId: number
  notificationStatus: UserNotificationStatus
  notificationType: NotificationType
  message: string
  createdDate: Date
}
